import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    grid: {
        width: '100%',
        background: '#0F5FAF'
    },

    paper: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '5px',
        color: '#000',
        background: '#6AADE4',
    },
    whitePaper:{
        padding: theme.spacing(0),
        textAlign: 'left',
        borderRadius: '5px',
        marginLeft: '50px',
        marginRight: '50px',
        background: '#FFF',
    },

    paper1: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '0px',
        color: theme.palette.text.secondary,
        background: '#6AADE4',
    },

    paper_left: {
        padding: theme.spacing(0),
        textAlign: 'left',
        borderRadius: '0px',
        color: theme.palette.text.secondary,
        background: 'transparent',
        marginTop: '5px',
    },

    paper_center: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '0px',
        color: theme.palette.text.secondary,
        background: 'transparent',
        marginTop: '5px',
    },

    paper_small: {
        padding: theme.spacing(0),
        textAlign: 'center',
        width: '35%',
        height: '100%',
        borderRadius: '5px',
        color: theme.palette.text.secondary,
        background: 'transparent',
        marginTop: '5px',
    },
    paper_big: {
        padding: theme.spacing(0),
        textAlign: 'center',
        width: '65%',
        height: '100%',
        borderRadius: '5px',
        color: theme.palette.text.secondary,
        background: 'transparent',
        marginTop: '5px',
    },

    mainIMG: {
        width: '60%',
        height: '60%',
        marginTop: '8px',
    },
    logo2IMG: {
        margin: '5px',
        width: '200px',
        height: '140px',
    },
    logoImg: {
        margin: '5px',
        width: '170px',
        height: '130px',
    },
    buttonGroup: {
        paddingLeft: '17%',
    },
    blueText: {
        color: '#0F5FAF',
    },

    blackText: {
        color: '#000',
    },
    whiteText: {
        color: '#FFF',
    },
    com: {
        margin: '50px',
        color: '#000',
    },
    groupPaper:{
        padding: theme.spacing(0),
        textAlign: 'left',
        borderRadius: '5px',
        margin: '10px',
        color: '#000',
        background: '#6AADE4',
    },
    logo3IMG:{
        margin: '5px',
        width: '800px',
        height: '550px',
    },
}));

export default useStyles;
